import React, { Component } from 'react'
import './Toolbar.css'
import NavigationItems from '../NavigationItems/NavigationItems'
import Input from '../UI/Input/Input'
import Button from '../UI/Button/Button'
import User from '../Navigation/User/User'
import Modal from '../UI/Modal/Modal'
import { Redirect } from 'react-router-dom'
import SideBar from '../UI/SideBar/SideBar'
import { withRouter } from 'react-router-dom'
import Login from '../../containers/Login/Login'
import Logo from '../../assets/images/logo.png'

        class Toolbar extends Component {

    state = {
        token: '',
        login: false,
        retriveOrder: false,
        retrive:
                {
                    trackingCode: {
                        elementType: 'input',
                        elementConfig: {
                            type: 'text',
                            placeholder: 'کد رهگیری'
                        },
                        validation: {
                        },
                        errorMessage: '',
                        valid: true,
                        value: ''
                    }
                }
    }

    componentWillMount() {
        this.setState({token: window.localStorage.getItem("token")})
    }

    componentWillReceiveProps() {
        this.setState({token: window.localStorage.getItem("token")})
    }

    inputChangedHandler = (event) => {
        const retrive = this.state.retrive
        retrive['trackingCode'].value = event.target.value
        this.setState({retrive: retrive, retriveOrder: false})
    }

    retriveTrackingCode = (event) => {
        this.setState({retriveOrder: true})
    }

    setTokenValue = () => {
        const tokenValue = window.localStorage.getItem("token")
        this.setState({token: tokenValue})
    }
    openLogin = (event) => {
        this.refs.child.openModal()
    }
    closeSideBar = (event) => {

    }
    render() {
        const formElementsArray = [];
        for (let key in this.state.retrive) {
            formElementsArray.push({
                id: key,
                config: this.state.retrive[key]
            });
        }
        let form = formElementsArray.map(formElement => {
            return (
                    <Input
                        key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        placeholder={formElement.config.placeholder}
                        float="no"
                        className="TrackCode"
                        errorMessage={formElement.config.errorMessage}
                        col="12 mt-3 p-0 float-left"
                        changed={(event) => this.inputChangedHandler(event, formElement.id)} />
                    );
        });

        const content = <Login closeLoginModal={() => closeLogin()} />

        const closeLogin = () => {
            this.refs.child.closeModal();
        }
        const afterCloseModal = (event) => {
            this.props.history.push('/')
            // this.setTokenValue()
        }
        let trackOrder = ''
        const token = this.props.token
        const path = 'my-orders' + '?orderNumber=' + this.state.retrive.trackingCode.value
        if (this.state.retriveOrder == true) {
            trackOrder = <Redirect to={path} />
        }
        return (
                <div className="toolbar-cntnr">
                
                    <section className="section sectionHeader LargeOnly">
                        <div className="row w-100 mr-5">
                            <div className="row w-75">
                                <div className="User">
                                    {this.state.token != '' && this.state.token != null ?
                                    <User setToken={() => this.setTokenValue()} />
                                                : ''
                                    }
                                </div>
                                <div className="RetriveCntnr1">
                                    <div className="row justify-content-center">
                                        <div className="RetriveInput">
                                            {form}
                                        </div>
                                        <div className="TrackingBtnCntnr">
                                            <Button clicked={this.retriveTrackingCode} className="TrackingBtn">پیگیری سفارش</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="toolbar-logo-cntnr">
                                <img class="toolbar-logo" src={Logo} />
                            </div>
                        </div>
                    </section>
                
                    <div className="ToolbarContent" >
                        <div className="mainMenuWrap">
                            <NavigationItems login={this.openLogin} token={this.state.token} setToken={this.setTokenValue} closeSideBar={this.closeSideBar} />
                        </div>
                        <div className="SmallNav">
                            <SideBar token={this.state.token} getLogin={this.openLogin} list={ < NavigationItems / > } />
                        </div>
                    </div>
                    <Modal
                        with="480px"
                        content={content}
                        ref="child"
                        closePermission={true}
                        closeModal={(event) => afterCloseModal(event)}
                        />
                    {trackOrder}
                </div>
                        )
            }
        }

        export default withRouter(Toolbar);